/* @flow */
import React from 'react';
import { proxyCounterpart } from '../../scripts/proxyCounterpart';
import Translate from 'react-translate-component';

export class PrivacyPolicy extends React.Component {

  render () {
    return (
      <div className='privacy-policy'>
        <Translate content='FF_TERMS_AND_PERSONAL_INFORMATION_BEING_TREATED'/>&nbsp;
        Frilans Finans <a href={proxyCounterpart('FOOTER_LINK_PRIVACY_POLICY')} target="_blank">
          <Translate content='PRIVACY_POLICY'/>
        </a>
      </div>
    );
  }
}

export default PrivacyPolicy;



/** WEBPACK FOOTER **
 ** ./src/components/privacy-policy/privacy-policy.js
 **/